import React, { useEffect, useState } from "react";
import axios from "../../../../Axiosinstance";
import TablePagination from "@mui/material/TablePagination"; // Import TablePagination component
import {
  Table,
  TableBody,
  TableCell,
  ButtonGroup,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Typography,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
  Link,
  IconButton,
  Grid,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SendIcon from "@mui/icons-material/Send"; // Import the SendIcon
import { Modal, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import InputAdornment from "@mui/material/InputAdornment";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { PauseCircleOutline } from "@mui/icons-material";
import { format } from "date-fns";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsPencilFill, BsTrashFill } from 'react-icons/bs'

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import calibriFontBold from "../../../../fonts/CalibriBold.ttf";
import calibriFont from "../../../../fonts/calibri.ttf";
import fontkit from "@pdf-lib/fontkit";
import Invoice_self from "../../../DOC/WSQ-Invoice-self.pdf";
import PhoneInput from 'react-phone-input-2';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../../../../common';
const StudentTable = ({ batchId }) => {
  const [students, setStudents] = useState([]);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [studentDocuments, setStudentDocuments] = useState({});
  const [statusFilter, setStatusFilter] = useState("");
  const [nricFilter, setNricFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [studentsPerPage, setStudentsPerPage] = useState(10);
  const [totalStudents, setTotalStudents] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const Name = localStorage.getItem("name");
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [salesPersons, setSalesPersons] = useState([]);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
  const [openConfirmApproveModal, setOpenConfirmApproveModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");


  const [openDialog, setOpenDialog] = useState(false); // Dialog open/close state
  const [selectedStudentdata, setSelectedStudentdata] = useState(null); // Store selected student
  const [formDataEdit, setFormDataEdit] = useState({
    fee: '',
    name: '',
    idType: '',
    nric: '',
    dob: '',
    contactNumber: [''], // Initialize with an empty array
    registration_Form: '',
    ic: '',
    supporting_Documents: '',
    discountAmount: 0,
    nationality: '',
    emailId: [''], // Initialize with an empty array
  });
  useEffect(() => {
    if (selectedStudentdata) {
      setFormDataEdit({

        name: selectedStudentdata.name || '',
        idType: selectedStudentdata.idType || '',
        nric: selectedStudentdata.nric || '',
        dob: formatDate(selectedStudentdata.dob) || '',
        contactNumber: selectedStudentdata.contactNumber.length ? selectedStudentdata.contactNumber : [''],
        registration_Form: selectedStudentdata.registration_Form || '',
        ic: selectedStudentdata.ic || '',
        supporting_Documents: selectedStudentdata.supporting_Documents || '',
        discountAmount: selectedStudentdata.discountAmount || 0,
        nationality: selectedStudentdata.nationality || '',
        emailId: selectedStudentdata.emailId.length ? selectedStudentdata.emailId : [''],
        fee: selectedStudentdata.fee || 0
      });
    }
  }, [selectedStudentdata]);


  const showToast = (message, type) => {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    if (batchId) {
      fetchStudentData(
        batchId,
        statusFilter,
        nricFilter,
        currentPage,
        studentsPerPage
      );
    }
    fetchSalesPersons();
  }, [batchId, statusFilter, currentPage, studentsPerPage]);

  const fetchSalesPersons = () => {
    axios
      .get("/wsq/sales-person/basic-info")
      .then((response) => {
        setSalesPersons(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching salespersons data!", error);
      });
  };

  const fetchStudentData = (batchId, status, nric, page, size) => {
    setIsLoading(true);
    axios
      .get(`/wsq/students`, {
        params: {
          page: page - 1,
          size: size,
          batchId: batchId,
          status: status,
          nric: nric,
        },
      })
      .then((response) => {
        setStudents(response.data.content);
        setTotalStudents(response.data.totalElements);
      })
      .catch((error) => {
        console.error("There was an error fetching student data!", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleApproveClick = (student, status, withDiscount) => {
    // setIsProcessing(true);
    setSelectedStudent(student);
    if (status === "approve") {


      // Open confirmation modal if no discount
      setOpenConfirmApproveModal(true);

    } else if (status === "hold") {
      setOpenHoldModal(true);
    } else if (status === "reject") {
      setOpenRejectModal(true);
    }
  };

  const handleConfirmApprove = async (status) => {
    // if (!discountAmount) return; // Prevent submission if the field is empty
    setIsSubmitting(true);
    setIsProcessing(true);
    try {
      await axios.put(`/wsq/${selectedStudent.id}/approve`, null, {
        params: {

          approve: Name,
          status: status,
        },
      });

      fetchStudentData(
        batchId,
        statusFilter,
        nricFilter,
        currentPage,
        studentsPerPage
      );
      handleCloseModals();
    } catch (error) {
      console.error("There was an error updating the student status!", error);
    } finally {
      setIsSubmitting(false);
      setIsProcessing(false);
    }
  };

  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSalesPersonChange = (event, studentId) => {
    const selectedSalesPersonId = event.target.value;
    const selectedSalesPerson = salesPersons.find(
      (person) => person.id === selectedSalesPersonId
    );

    if (selectedSalesPerson) {
      setSelectedSalesPerson(selectedSalesPersonId);
      setSelectedStudentId(studentId);
      setIsModalOpen(true); // Open the modal for confirmation
    }
  };

  const handleConfirm = async () => {
    const apiUrl = `/wsq/assignSalesperson?studentId=${selectedStudentId}&salespersonId=${selectedSalesPerson}`;

    try {
      const response = await axios.post(apiUrl);
      if (response.status === 200) {
        console.log("Salesperson assigned successfully!");
        fetchStudentData(
          batchId,
          statusFilter,
          nricFilter,
          currentPage,
          studentsPerPage
        );
      } else {
        console.error("Failed to assign salesperson.");
      }
    } catch (error) {
      console.error("Error assigning salesperson:", error);
    }

    setIsModalOpen(false); // Close the modal
  };

  const handleCancel = () => {
    setSelectedSalesPerson(null);
    setSelectedStudentId(null);
    setIsModalOpen(false);
  };

  const handleDiscountChange = (event) => {
    setDiscountAmount(event.target.value);
  };

  const handleCloseModals = () => {
    setOpenApproveModal(false);
    setOpenDiscountModal(false);
    setOpenConfirmApproveModal(false); // Close confirmation modal
    setOpenHoldModal(false);
    setOpenRejectModal(false);
    setSelectedStudent(null);
    setDiscountAmount(0);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
    setCurrentPage(1);
  };

  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  const handlePaymentTypeChange = (event, studentId) => {
    const paymentType = event.target.value;
    setSelectedPaymentType(paymentType);
    setSelectedStudentId(studentId);
    setIsPaymentModalOpen(true); // Open modal for confirmation
  };

  const handleConfirmPaymentType = async () => {
    const apiUrl = `/wsq/PaymentType?studentId=${selectedStudentId}&paymentType=${selectedPaymentType}`;

    try {
      const response = await axios.post(apiUrl);
      if (response.status === 200) {
        console.log("Payment type assigned successfully!");
        fetchStudentData(
          batchId,
          statusFilter,
          nricFilter,
          currentPage,
          studentsPerPage
        );
      } else {
        console.error("Failed to assign payment type.");
      }
    } catch (error) {
      console.error("Error assigning payment type:", error);
    }

    setIsPaymentModalOpen(false); // Close modal
  };

  const handleCancelPaymentType = () => {
    setSelectedPaymentType(null);
    setSelectedStudentId(null);
    setIsPaymentModalOpen(false); // Close modal without making API call
  };

  const handleNricChange = (event) => {
    const value = event.target.value;
    setNricFilter(value);
    if (value === "") {
      setStatusFilter("");
      setCurrentPage(1);
      fetchStudentData(batchId, "", "", currentPage, studentsPerPage);
    }
  };

  const handlePageSizeChange = (event) => {
    setStudentsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchStudentData(
      batchId,
      statusFilter,
      nricFilter,
      currentPage,
      studentsPerPage
    );
  };

  const totalPages = Math.ceil(totalStudents / studentsPerPage);

  const handleResendEmail = async (student) => {
    const { id, status } = student;

    // Set loading state to true for the clicked student
    student.isLoading = true;
    setStudents([...students]); // Update the student state to trigger a re-render

    let apiUrl;

    // Set the appropriate API URL based on the status
    if (status === "new") {
      apiUrl = `/wsq/companies/resend-email-self-register/${id}`;
    } else if (status === "approve") {
      apiUrl = `/wsq/${id}/resend-email`;
    } else {
      console.log("No action for this status");
      student.isLoading = false; // Reset loading state
      setStudents([...students]);
      return;
    }

    // Call the API to resend the email
    try {
      const response = await axios.post(apiUrl);
      if (response.status === 200) {
        fetchStudentData(
          batchId,
          statusFilter,
          nricFilter,
          currentPage,
          studentsPerPage
        );
      } else {
        alert("Failed to resend email.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error resending email.");
    } finally {
      // Reset loading state after API call
      student.isLoading = false;
      setStudents([...students]);
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);

  // Handle the click on invoice number to fetch student details
  const handleClickInvoiceNumber = async (studentId) => {
    try {
      const response = await axios.get(`/wsq/${studentId}/details`);
      setStudentDetails(response.data); // Save student data to state
      setOpenModal(true); // Open the modal
      handleInvoicePdf(response.data);
    } catch (error) {
      console.error("Error fetching student details:", error);
    }
  };

  const handleInvoicePdf = async (data) => {
    const pdfBytes = await fetch(Invoice_self).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    const secondPage = pages[1];
    pdfDoc.registerFontkit(fontkit);



    const calibriFontEmbed = pdfDoc.embedStandardFont(StandardFonts.Helvetica);

    const contactNumber = data?.contactNumber?.join(", ") || "";
    const language = data?.language || "";
    const courseName = data?.courseName || "";
    const discountAmount = data?.discountAmount || "";
    const feeAmount = data?.feeAmount || "";
    const invoiceDate = data?.invoiceDate || "";
    const invoiceNumber = data?.invoiceNumber || "";
    const studentName = data?.studentName || "";

    const studentNric = data?.studentNric || "";

    const totalAmount = data?.totalAmount || "";

    const salesperson = data?.salespersonName || "";
    const batchid = data?.batchId || "";
    const venueStreet = data?.venueStreet || "";
    const sessionDetails = data?.sessionDetails || "";
    const issuedby = "CD";
    const startDate1 = data?.startDate || "";
    const endDate = data?.endDate || "";
    const paymentMode = data?.paymentMode || "";

    const fontsize = 10;

    firstPage.drawText(studentName, {
      x: 102,
      y: 680,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(contactNumber, {
      x: 125,
      y: 664,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });


    firstPage.drawText(invoiceNumber, {
      x: 430,
      y: 680,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(invoiceDate, {
      x: 400,
      y: 664,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    firstPage.drawText(salesperson, {
      x: 432,
      y: 647,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    firstPage.drawText(issuedby, {
      x: 420,
      y: 629,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    firstPage.drawText(paymentMode, {
      x: 446,
      y: 613,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });
    //inside table

    firstPage.drawText("1", {
      x: 380,
      y: 460,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${feeAmount}`, {
      x: 415,
      y: 460,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${discountAmount}`, {
      x: 472,
      y: 460,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(`$${totalAmount}`, {
      x: 520,
      y: 460,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${(totalAmount * 0.09).toFixed(2)}`, {
      x: 520,
      y: 340,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${0}`, {
      x: 525,
      y: 315,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(`$${0}`, {
      x: 525,
      y: 290,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    const dis = (discountAmount * 0.9);
    const total = (Number(totalAmount) + Number(dis));

    firstPage.drawText(`$${data.totalPayWithGst}`, {
      x: 522,
      y: 265,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(studentName, {
      x: 62,
      y: 390,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });
    firstPage.drawText(studentNric, {
      x: 295,
      y: 390,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(0, 0, 0),
    });


    firstPage.drawText(startDate1, { x: 72, y: 120, size: fontsize, font: calibriFontEmbed, color: rgb(0, 0, 0) });

    firstPage.drawText(endDate, { x: 179, y: 120, size: fontsize, font: calibriFontEmbed, color: rgb(0, 0, 0) });


    function formatStartDate(startDate1) {
      let date;

      // Check if startDate1 is already a Date object
      if (startDate1 instanceof Date) {
        date = startDate1;
      } else {
        // If it's a string, manually parse it
        const parts = startDate1.split('/');
        const day = parts[0];
        const month = parts[1] - 1; // JavaScript months are 0-indexed
        const year = parts[2];
        date = new Date(year, month, day); // Create Date object
      }

      const formattedDay = String(date.getDate()).padStart(2, "0");
      const formattedMonth = String(date.getMonth() + 1).padStart(2, "0");
      const formattedYear = date.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`; // Return formatted date
    }

    // Utility function to calculate the due date based on payment mode
    function calculateDueDate(startDate1, paymentMode) {
      let date;

      // Check if startDate1 is already a Date object
      if (startDate1 instanceof Date) {
        date = startDate1;
      } else {
        // If it's a string, manually parse it
        const parts = startDate1.split('/');
        const day = parts[0];
        const month = parts[1] - 1; // JavaScript months are 0-indexed
        const year = parts[2];
        date = new Date(year, month, day); // Create Date object
      }

      // Determine due date based on payment mode
      switch (paymentMode) {
        case "7 days":
          date.setDate(date.getDate() + 7);
          break;
        case "15 days":
          date.setDate(date.getDate() + 15);
          break;
        case "30 days":
          date.setDate(date.getDate() + 30);
          break;
        case "COD":
          return formatStartDate(startDate1); // Return the formatted start date
        case "GIRO":
          return "GIRO"; // Return "GIRO" as the value
        default:
          return startDate1; // Return placeholder for invalid modes
      }

      // Format the calculated due date as DD/MM/YYYY
      return formatStartDate(date);
    }

    const duedate = calculateDueDate(startDate1, paymentMode);

    firstPage.drawText(duedate, { x: 420, y: 595, size: fontsize, font: calibriFontEmbed, color: rgb(1, 1, 1) });

    //sessionDetails time

    let y = 120; // Starting Y-coordinate
    const x = 300; // X-coordinate
    const lineSpacing = 12; // Space between lines
    let dayCounter = 1;

    for (const session of sessionDetails) {
      // Extract the date from the session detail
      const dateMatch = session.match(/\d{2}\/\d{2}\/\d{4}/);
      const sessionDate = dateMatch ? dateMatch[0] : ""; // Keep the date as DD/MM/YYYY

      // Extract the session times
      const timeMatch = session.match(/\((.+)\)/);
      const sessionTime = timeMatch ? timeMatch[1] : "";

      // Split the session times into start and end and format them
      const [startTime, endTime] = sessionTime.split(" - ");
      const formatTime = (time) =>
        time.replace(/\b(\d{1,2}):(\d{2})/, (match, h, m) => {
          const hour = parseInt(h, 10);
          return `${hour % 12 || 12}:${m} ${hour < 12 ? "AM" : "PM"}`;
        });
      const formattedSession = `${formatTime(startTime)} TO ${formatTime(endTime)}`;

      // Draw the formatted text
      firstPage.drawText(
        `Day: ${dayCounter}   ${sessionDate}   ${formattedSession}`,
        {
          x: x,
          y: y,
          size: 9,
          font: calibriFontEmbed,
          color: rgb(0, 0, 0),
        }
      );

      y -= lineSpacing; // Move to the next line
      dayCounter++;
    }




    //for date
    // let ybatchDays = 200; // Starting Y-coordinate
    // const xbatchDays = 190;
    // const lineSpacingdays = 12;
    // for (const batch of batchDays) {
    //   firstPage.drawText(batch, {
    //     x: xbatchDays,
    //     y: ybatchDays,
    //     size: fontsize,
    //     font: calibriFontEmbed,
    //     color: rgb(0, 0, 0),
    //   });
    //   ybatchDays -= lineSpacingdays; // Move to the next line
    // }


    function abbreviateCourseName(courseName) {
      return courseName
        .split(' ') // Split the string into words
        .filter(word => word.trim().length > 0) // Filter out empty or whitespace-only words
        .map(word => word[0].toUpperCase()) // Take the first letter of each word and convert it to uppercase
        .join(''); // Join the letters to form the abbreviation
    }

    const getTextWidth = (text, font, fontSize) => {
      const width = font.widthOfTextAtSize(text, fontSize);
      return width;
    };


    function replaceTabs(text) {
      if (typeof text !== 'string') {
        return ''; // Return an empty string if the input is not a valid string
      }
      return text.replace(/\t/g, '    '); // Replace each tab with four spaces
    }

    // Function to draw wrapped text with dynamically adjusted X-axis position
    const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth, textColor = rgb(0, 0, 0)) => {
      text = replaceTabs(text);
      const lines = [];
      let currentLine = '';
      const words = text.split(' ');

      // Split the text into lines based on maxWidth
      for (let i = 0; i < words.length; i++) {
        const word = words[i];
        const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

        if (width < maxWidth) {
          currentLine += (currentLine === '' ? '' : ' ') + word;
        } else {
          lines.push(currentLine.trim());
          currentLine = word;
        }
      }

      if (currentLine !== '') {
        lines.push(currentLine.trim());
      }

      // Draw each line of wrapped text
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        await page.drawText(line, {
          x: x,  // Keep the initial X position for all lines
          y: y - i * fontSize * 1.2,  // Adjust the Y position for each line based on font size
          size: fontSize,
          font,
          color: textColor,
        });
      }

      // Return the total height of the wrapped text (based on the number of lines)
      return lines.length * fontSize;
    };

    await drawWrappedText(firstPage, venueStreet, 123, 185, calibriFontEmbed, fontsize, 300, rgb(0, 0, 0));

    const totalHeightUsed = await drawWrappedText(firstPage, courseName, 126, 649, calibriFontEmbed, fontsize, 222, rgb(1, 1, 1));

    //   await drawWrappedText(firstPage, `${abbreviateCourseName(courseName)}-${language}`, 143, 215, calibriFontEmbed, fontsize, 70, rgb(0, 0, 0));

    firstPage.drawText(`${abbreviateCourseName(courseName)}-${language} `, { x: 143, y: 202, size: fontsize, font: calibriFontEmbed, color: rgb(0, 0, 0) });

    firstPage.drawText(`Batch ID: ${abbreviateCourseName(courseName)}-${batchid}`, {
      x: 69,
      y: 650 - totalHeightUsed - 5,
      size: fontsize,
      font: calibriFontEmbed,
      color: rgb(1, 1, 1),
    });

    await drawWrappedText(firstPage, `${courseName}`, 62, 466, calibriFontEmbed, fontsize, 298, rgb(0, 0, 0));


    // Save the PDF document
    // const pdfBytesEdited = await pdfDoc.save();
    // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
    // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-COURSE-RECEIPT.pdf`);
    const pdfBytesModified = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytesModified], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
  };

  // Close the modal
  // Close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setStudentDetails(null); // Clear student data when closing the modal
  };


  const handleEditClick = (student) => {
    setSelectedStudentdata(student);
    setOpenDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedStudentdata(null);
  };

  const handleArrayChangeEdit = (field, index, value) => {
    const updatedArray = [...formDataEdit[field]];
    updatedArray[index] = value;
    setFormDataEdit((prevState) => ({ ...prevState, [field]: updatedArray }));
  };

  const addArrayItemEdit = (field) => {
    setFormDataEdit((prevState) => ({ ...prevState, [field]: [...prevState[field], ''] }));
  };

  const removeArrayItemEdit = (field, index) => {
    const updatedArray = formDataEdit[field].filter((_, i) => i !== index);
    setFormDataEdit((prevState) => ({ ...prevState, [field]: updatedArray }));
  };

  const handleChangeEdit = (e) => {
    console.log(e.target.value)
    const { name, value } = e.target;
    setFormDataEdit((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChangeEdit = (e, fieldName) => {
    handleFileUpload(e, 0, 0, fieldName); // Assuming single student for now
  };

  const handleFileUpload = async (e, contactIndex, studentIndex, fieldName) => {
    try {
      const file = e.target.files[0]; // Get the first file from the input
      if (!file) return; // Exit if no file is selected

      const formDataUpload = new FormData();
      formDataUpload.append('file', file); // Append the file to the FormData object
      formDataUpload.append('upload_preset', CLOUDINARY_UPLOAD_PRESET); // Add the upload preset for Cloudinary

      // Send the file to Cloudinary
      const response = await fetch(baseURL, {
        method: 'POST',
        body: formDataUpload,
      });

      const data = await response.json(); // Parse the response

      // Check if the upload was successful
      if (data.secure_url) {
        const uploadedFileUrl = data.secure_url; // Get the URL of the uploaded file

        // Update the state with the uploaded file URL
        setFormDataEdit((prevState) => ({
          ...prevState,
          [fieldName]: uploadedFileUrl, // Use the fieldName to dynamically set the URL
        }));
      } else {
        console.error('File upload failed:', data); // Handle error if URL is not present
      }
    } catch (err) {
      console.error('File upload error:', err); // Log any other errors
    }
  };


  const handleSubmitEdit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    console.log('Form Data Edit:', formDataEdit); // Log current form data

    const studentId = selectedStudentdata.id;

    axios.put(`wsq/${studentId}/selfStudent`, formDataEdit)
      .then(response => {
        console.log("First API response:", response.data);
        handleCloseDialog();

        // Call fetchStudentData after successful API response
        fetchStudentData(
          batchId,
          statusFilter,
          nricFilter,
          currentPage,
          studentsPerPage
        );
      })
      .catch(error => {
        console.error("There was an error with the API request!", error);
      });
  };


  const formatDate = (isoDate) => {
    const date = new Date(isoDate); // Convert ISO string to Date object
    const year = date.getFullYear(); // Get full year
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad to 2 digits
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad to 2 digits
    return `${year}-${month}-${day}`; // Return in YYYY-MM-DD format
  };




  return (
    <Box>
      <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
        <Select
          value={statusFilter}
          onChange={handleStatusChange}
          displayEmpty
          sx={{ minWidth: 120, mr: 2 }}
        >
          <MenuItem value="">
            <em>All Status</em>
          </MenuItem>
          <MenuItem value="new">New</MenuItem>
          <MenuItem value="approve">Approved</MenuItem>
        </Select>
        <TextField
          label="Search NRIC"
          variant="outlined"
          value={nricFilter}
          onChange={handleNricChange}
          sx={{ width: 200, mr: 2 }}
        />
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Search
        </Button>
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Booking Id</TableCell>
                <TableCell> Registration Date and Time </TableCell>

                <TableCell>Name</TableCell>
                <TableCell align="left">Email</TableCell>
                <TableCell align="right">NRIC</TableCell>
                <TableCell align="right">Contact Number</TableCell>
                <TableCell align="right">Documents</TableCell>

                <TableCell align="right">Sales Person </TableCell>
                <TableCell align="right">Payment Type</TableCell>

                <TableCell align="left"> Fee</TableCell>
                <TableCell align="right">Special Fee</TableCell>
                <TableCell align="right">Actions</TableCell>
                <TableCell>Invoice</TableCell>
                <TableCell>Invoice Download</TableCell>
                <TableCell>Receipt</TableCell>
                <TableCell>Receipt Download</TableCell>
                <TableCell>Report</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {students.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography variant="body1">
                      No students found for this criteria.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                students.map((student) => (
                  <TableRow key={student.id}>
                    <TableCell>{student.registerId}</TableCell>
                    {student.registerDate
                      ? format(
                        new Date(student.registerDate),
                        "dd/MM/yyyy hh:mm a"
                      )
                      : "N/A"}
                    <TableCell>{student.name}</TableCell>
                    <TableCell align="right">{student.emailId}</TableCell>
                    <TableCell align="right">{student.nric}</TableCell>
                    <TableCell align="right">{student.contactNumber}</TableCell>
                    <TableCell align="right">
                      <>
                        <Link
                          href={student.registration_Form}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <InsertDriveFileIcon
                            color="primary"
                            titleAccess="Registration Form"
                          />
                        </Link>
                        <Link
                          href={student.ic}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <InsertDriveFileIcon
                            color="secondary"
                            titleAccess="IC"
                          />
                        </Link>
                        <Link
                          href={student.supporting_Documents}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <InsertDriveFileIcon
                            color="action"
                            titleAccess="Supporting Documents"
                          />
                        </Link>
                      </>
                    </TableCell>
                    <TableCell>
                      <Select
                        value={student.salespersonId || ""} // Default to empty if no value
                        onChange={(event) =>
                          handleSalesPersonChange(event, student.id)
                        }
                        displayEmpty
                        fullWidth
                        sx={{
                          fontSize: "1rem",
                          minWidth: 200,
                          height: 40,
                        }}
                      >
                        <MenuItem value="" disabled>
                          <em>
                            {student.salesPerson
                              ? student.salesPerson
                              : "Select Sales Person"}
                          </em>
                        </MenuItem>
                        {salesPersons.map((person) => (
                          <MenuItem key={person.id} value={person.id}>
                            {person.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>

                    <TableCell>
                      <Select
                        value={student.paymentType || ""} // Display paymentType if available; otherwise default to ""
                        onChange={(event) =>
                          handlePaymentTypeChange(event, student.id)
                        }
                        fullWidth
                        displayEmpty
                        sx={{
                          fontSize: "1rem", // Adjust font size
                          minWidth: 200, // Adjust dropdown width
                          height: 40, // Adjust height of dropdown
                        }}
                      >
                        <MenuItem value="" disabled>
                          <em>Select Payment Type</em> {/* Placeholder text */}
                        </MenuItem>
                        <MenuItem value="COD">COD</MenuItem>
                        <MenuItem value="7 days">7 days</MenuItem>
                        <MenuItem value="15 days">15 days</MenuItem>
                        <MenuItem value="30 days">30 days</MenuItem>
                        <MenuItem value="GIRO">GIRO</MenuItem>
                      </Select>
                    </TableCell>

                    {/* Conditionally render icons or status text */}

                    <TableCell align="right">${student.fee}</TableCell>
                    <TableCell align="right">
                      ${(student.fee - student.discountAmount).toFixed(2)}
                    </TableCell>

                    <TableCell align="right">
                      <ToastContainer />{" "}
                      {/* Ensure ToastContainer is included */}
                      {student.status === "new" ? (
                        <ButtonGroup variant="contained" color="primary">


                          {/* Without discount approval */}
                          <IconButton
                            color="success"
                            disabled={isProcessing}
                            onClick={() => {
                              if (
                                !student.salesPerson ||
                                !student.paymentType
                              ) {
                                showToast(
                                  "Please select a salesperson and payment type before approving.",
                                  "error"
                                );
                                return;
                              }
                              handleApproveClick(student, "approve", false); // without discount
                            }}
                            title="WApprove"
                          >
                            <CheckCircleIcon />
                          </IconButton>

                          {/* Reject button */}
                          <IconButton
                            color="error"
                            disabled={isProcessing}
                            onClick={() =>
                              handleApproveClick(student, "reject")
                            }
                            title="Reject"
                          >
                            <CancelIcon />
                          </IconButton>

                          {/* Hold button */}
                          <IconButton
                            color="warning"
                            disabled={isProcessing}
                            onClick={() => handleApproveClick(student, "hold")}
                            title="Hold"
                          >
                            <PauseCircleOutline />
                          </IconButton>
                        </ButtonGroup>
                      ) : (
                        <Typography variant="body2">
                          {student.status}
                        </Typography>
                      )}
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2"></Typography>
                      <Button
                        variant="contained"
                        endIcon={<MailOutlineIcon />} // Using the Mail Icon
                        onClick={() => handleResendEmail(student)} // Pass the student object
                        disabled={
                          student.status === "reject" ||
                          student.status === "hold" ||
                          student.isLoading // Disable when loading
                        }
                        sx={{
                          bgcolor: student.approveMailSent
                            ? "green" // Set to green if approveMailSent is true
                            : student.status === "approve"
                              ? "yellow"
                              : "primary.main", // Conditional color
                          color: student.approveMailSent
                            ? "white" // Set text color to white for green background
                            : student.status === "approve"
                              ? "black"
                              : "white", // Text color for yellow background
                          "&:hover": {
                            bgcolor: student.approveMailSent
                              ? "darkgreen" // Hover color for green button
                              : student.status === "approve"
                                ? "gold"
                                : "primary.dark", // Hover effect for yellow color
                          },
                        }}
                      >
                        {student.isLoading ? "Sending..." : "Email"}
                      </Button>
                    </TableCell>

                    <TableCell>
                      {student.status === "approve" && student.invoiceNumber ? (
                        <Button
                          onClick={() => handleClickInvoiceNumber(student.id)}
                        >
                          {student.invoiceNumber}
                        </Button>
                      ) : (
                        "Not Available"
                      )}
                    </TableCell>

                    <TableCell>
                      <Typography variant="body2"></Typography>
                      <Button variant="contained" endIcon={<SendIcon />}>
                        Send
                      </Button>
                    </TableCell>

                    <TableCell>Download</TableCell>

                    <TableCell>
                      <Select
                        value={student.status || ""} // Ensure the value is an empty string if no status is selected
                        onChange={(event) =>
                          handleStatusChange(event, student.id)
                        }
                        fullWidth
                        displayEmpty
                        sx={{
                          fontSize: "1rem", // Adjust font size
                          minWidth: 200, // Adjust dropdown width
                          height: 40, // Adjust height of dropdown
                        }}
                      >
                        <MenuItem value="" disabled>
                          <em>Select Status</em> {/* Placeholder text */}
                        </MenuItem>
                        <MenuItem value="Closed">Closed</MenuItem>
                        <MenuItem value="Cancel">Cancel</MenuItem>
                        <MenuItem value="Postponed">Postponed</MenuItem>
                        <MenuItem value="Absent">Absent</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => {
                        handleEditClick(student);
                        setOpenDialog(true);
                      }}>
                        <BsPencilFill />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={totalStudents}
        rowsPerPage={studentsPerPage}
        page={currentPage - 1}
        onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
        onRowsPerPageChange={handlePageSizeChange}
      />

      <Dialog open={isModalOpen} onClose={handleCancel}>
        <DialogTitle>Confirm Assignment</DialogTitle>
        <DialogContent>
          Are you sure you want to assign this salesperson to the student?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isPaymentModalOpen} onClose={handleCancelPaymentType}>
        <DialogTitle>Confirm Payment Type</DialogTitle>
        <DialogContent>
          Are you sure you want to assign the payment type{" "}
          <strong>{selectedPaymentType}</strong> to this student?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelPaymentType} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmPaymentType} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Modal for Approve */}
      <Modal show={openApproveModal} onHide={handleCloseModals} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Approval</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to approve{" "}
            <strong>{selectedStudent?.name}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="outline-secondary"
            onClick={handleCloseModals}
            className="px-4"
          >
            No
          </Button>
          <Button
            variant="primary"
            onClick={() => handleConfirmApprove("approve", 0)}
            className="px-4"
          >
            Yes, Proceed Without Discount
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openConfirmApproveModal} onHide={handleCloseModals}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Approval</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="body1">
            Are you sure you want to approve {selectedStudent?.name} ?
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleConfirmApprove("approve")}
          >
            Confirm Approval
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Discount Amount Modal */}
      <Modal
        show={openDiscountModal}
        onHide={handleCloseModals}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Enter Discount Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            label="Discount Amount"
            variant="outlined"
            type="number"
            value={discountAmount || ""}
            onChange={handleDiscountChange}
            fullWidth
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            helperText={
              !discountAmount
                ? "This field is required."
                : "Please enter a valid discount amount."
            }
            error={!discountAmount}
          />
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="contained"
            color="error"
            onClick={handleCloseModals}
            className="px-4"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleConfirmApprove("approve")}
            className="px-4"
            disabled={!discountAmount || isSubmitting}
          >
            {isSubmitting ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Submit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Hold Confirmation Modal */}
      <Modal show={openHoldModal} onHide={handleCloseModals} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Hold</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to hold <strong>{selectedStudent?.name}</strong>
          ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="warning"
            onClick={() => handleConfirmApprove("hold")}
          >
            Confirm Hold
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reject Confirmation Modal */}
      <Modal show={openRejectModal} onHide={handleCloseModals} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Rejection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to reject{" "}
          <strong>{selectedStudent?.name}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseModals}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => handleConfirmApprove("reject")}
          >
            Confirm Reject
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal to display student details */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="student-details-modal"
        aria-describedby="modal-to-view-student-details"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          {studentDetails ? (
            <>
              <Typography variant="h6" component="h2">
                {studentDetails.studentName} - {studentDetails.courseName}
              </Typography>
              <Typography variant="body1">
                Contact Number: {studentDetails.contactNumber}
              </Typography>
              <Typography variant="body1">
                Batch Name: {studentDetails.batchName}
              </Typography>
              <Typography variant="body1">
                Invoice Number: {studentDetails.invoiceNumber}
              </Typography>
              <Typography variant="body1">
                Invoice Date: {studentDetails.invoiceDate}
              </Typography>
              <Typography variant="body1">
                Fee Amount: {studentDetails.feeAmount}
              </Typography>
              <Typography variant="body1">
                Discount Amount: {studentDetails.discountAmount}
              </Typography>
              <Typography variant="body1">
                Total Amount: {studentDetails.totalAmount}
              </Typography>
              {/* <Typography variant="body1">
                Batch Days: {studentDetails?.batchDays?.join(", ")}
              </Typography> */}
              <Typography variant="body1">
                Session Details: {studentDetails?.sessionDetails.join(", ")}
              </Typography>
              <Typography variant="body1">
                Venue Street: {studentDetails.venueStreet}
              </Typography>
              <Typography variant="body1">
                Student NRIC: {studentDetails.studentNric}
              </Typography>
            </>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
          <Button onClick={handleCloseModal} sx={{ mt: 2 }}>
            Close
          </Button>
        </Box>
      </Modal>
      {/* //for edit student modal */}
      <Modal
        show={openDialog}
        onHide={handleCloseDialog}
        centered
        size="lg"
        style={{ overflow: 'hidden' }} // Ensures the modal itself doesn't overflow
      >           {/* //for edit student modal */}

        <Modal.Header
          closeButton
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: 'white',
            borderBottom: '1px solid #ddd',
          }}
        >
          <Modal.Title>Edit student</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: '80vh', // Set the max height for the body
            overflowY: 'auto', // Enable vertical scrolling when content overflows
          }}
        >
          {/* <form onSubmit={handleSubmitEdit}> */}
          <TextField
            label="Full Name (As per NRIC)"
            name="name"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={formDataEdit.name}
            onChange={handleChangeEdit}
          />
          <TextField
            label="ID Type"
            name="idType"
            select
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={formDataEdit.idType}
            onChange={handleChangeEdit}
          >
            <MenuItem value="NRIC">NRIC</MenuItem>
            <MenuItem value="FIN">FIN</MenuItem>
            <MenuItem value="Passport">Passport</MenuItem>
          </TextField>
          <TextField
            label="ID"
            name="nric"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={formDataEdit.nric}
            onChange={handleChangeEdit}
          />
          <TextField
            label="Date of Birth"
            name="dob"
            type="date"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            InputLabelProps={{
              shrink: true,
            }}
            value={formDataEdit.dob}
            onChange={handleChangeEdit}
          />

          <Typography variant="h6" gutterBottom>
            Contact Numbers
          </Typography>
          {formDataEdit.contactNumber.map((contactNumber, index) => (
            <Grid container alignItems="center" spacing={1} key={`contact-${index}`} style={{ marginBottom: '10px' }}>
              <Grid item xs={10}>
                <PhoneInput
                  country={'sg'}
                  value={contactNumber}
                  onChange={(value) => handleArrayChangeEdit('contactNumber', index, value)}
                  inputStyle={{ width: '100%', height: '56px', borderRadius: '4px' }}
                />
              </Grid>
              <Grid>
                <IconButton color="primary" onClick={() => addArrayItemEdit('contactNumber')}>
                  <AddCircleOutlineIcon />
                </IconButton>
              </Grid>
              <Grid>
                {index > 0 && (
                  <IconButton color="error" onClick={() => removeArrayItemEdit('contactNumber', index)}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          ))}
          <Typography variant="h6" gutterBottom>
            Email Addresses
          </Typography>
          {formDataEdit.emailId.map((email, index) => (
            <Grid container alignItems="center" spacing={1} key={`email-${index}`} style={{ marginBottom: '10px' }}>
              <Grid item xs={10}>
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  fullWidth
                  required
                  value={email}
                  onChange={(e) => handleArrayChangeEdit('emailId', index, e.target.value)}
                />
              </Grid>
              <Grid>
                <IconButton color="primary" onClick={() => addArrayItemEdit('emailId')}>
                  <AddCircleOutlineIcon />
                </IconButton>
              </Grid>
              <Grid>
                {index > 0 && (
                  <IconButton color="error" onClick={() => removeArrayItemEdit('emailId', index)}>
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          ))}

          <TextField
            label="Discount Amount"
            name="discountAmount"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formDataEdit.discountAmount}
            onChange={(e) => {
              const value = e.target.value;
              if (value <= formDataEdit.fee) {
                handleChangeEdit(e);
                setError(false); // Clear error state
              } else {
                setError(true); // Set error state
              }
            }}
            type="number"
            error={error}
            helperText={error ? `Discount cannot exceed the fee (${formDataEdit.fee}).` : ''}
          />

          <Typography variant="h6" gutterBottom>
            Upload Documents:
          </Typography>
          {['registration_Form', 'ic', 'supporting_Documents'].map((field, index) => (
            <div key={field} style={{ marginBottom: '10px' }}>
              <Button
                variant="contained"
                component="label"
                fullWidth
                startIcon={<CloudUpload />}
                sx={{ backgroundColor: '#1976d2', color: '#fff' }}
              >
                Upload {field.replace('_', ' ')}
                <input
                  type="file"
                  hidden
                  accept=".pdf,.jpg,.png"
                  onChange={(e) => handleFileChangeEdit(e, field)}
                />
              </Button>
              {formDataEdit[field] && (
                <Link
                  href={formDataEdit[field]}
                  target="_blank"
                  rel="noopener"
                  style={{ display: 'block', marginTop: '5px' }}
                >
                  {formDataEdit[field].split('/').pop() || "View uploaded Document"}
                </Link>
              )}
            </div>
          ))}



        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" color="secondary" onClick={handleCloseDialog}>
            Cancel
          </Button>
          <p></p>
          <Button
            variant="outlined" color="primary"
            onClick={handleSubmitEdit}
          >
            submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

export default StudentTable;
